import React, { Component } from "react";
import {
  Table, Form, Icon, Popup, Grid, Image,
  Segment, Divider, Statistic, Accordion
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

const statusKeyArray = [Strings.GOOD_STRING, Strings.BAD_STRING, Strings.ATTENTION_STRING];
const statusValueArray = [Constants.GOOD, Constants.BAD, Constants.ATTENTION];

class LiveList extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      baudrate: 0,
      nMasters: 0,
      nSlaves: 0,
      tensaoIdle: 0,
      networkTag: "",
      firstScanFail: false,
      wrongSerial: false,
      InitPicoNotFound: false,
      invertedAB: false,
      scanFail: false,
      errorMessages: [],
      monitorAddr: "",
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => {
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  addSeverityLevelToDevices = () => {
    let devicesCopy = this.state.devices;
    let originalDevicesCopy = this.state.originalDevices;

    for (let i = 0; i < devicesCopy.length; i++) {
      if (devicesCopy[i].status === Constants.BAD) {
        devicesCopy[i].severity = 4;
      } else if (devicesCopy[i].status === Constants.ATTENTION) {
        devicesCopy[i].severity = 3;
      } else if (devicesCopy[i].status === Constants.GOOD) {
        devicesCopy[i].severity = 2;
      } else {
        devicesCopy[i].severity = 1;
      }
    }

    for (let i = 0; i < originalDevicesCopy.length; i++) {
      if (originalDevicesCopy[i].status === Constants.BAD) {
        originalDevicesCopy[i].severity = 4;
      } else if (originalDevicesCopy[i].status === Constants.ATTENTION) {
        originalDevicesCopy[i].severity = 3;
      } else if (originalDevicesCopy[i].status === Constants.GOOD) {
        originalDevicesCopy[i].severity = 2;
      } else {
        originalDevicesCopy[i].severity = 1;
      }
    }

    this.setState({
      devices: devicesCopy,
      originalDevices: originalDevicesCopy
    });
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the live list by tag ascending
    if (clickedColumn === "tag" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by tag descending
    else if (clickedColumn === "tag" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by address ascending
    else if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by address descending
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by amplitude ascending
    else if (clickedColumn === "amplitude" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitude",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by amplitude descending
    else if (clickedColumn === "amplitude" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitude",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by min amplitude ascending
    else if (clickedColumn === "minAmplitude" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitudeMin",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by min amplitude descending
    else if (clickedColumn === "minAmplitude" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitudeMin",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by responseTime ascending
    else if (clickedColumn === "responseTime" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "responseTime",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by responseTime descending
    else if (clickedColumn === "responseTime" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "responseTime",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by responseTimeMin ascending
    else if (clickedColumn === "responseTimeMin" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "responseTimeMin",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by responseTimeMin descending
    else if (clickedColumn === "responseTimeMin" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "responseTimeMin",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by responseTimeMax ascending
    else if (clickedColumn === "responseTimeMax" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "responseTimeMax",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by responseTimeMax descending
    else if (clickedColumn === "responseTimeMax" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "responseTimeMax",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by noise descending
    else if (clickedColumn === "noise" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "noise",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by noise descending
    else if (clickedColumn === "noise" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "noise",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by A descending
    else if (clickedColumn === "aOk" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "aOk",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by A descending
    else if (clickedColumn === "aOk" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "aOk",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by B ascending
    else if (clickedColumn === "bOk" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "bOk",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by B descending
    else if (clickedColumn === "bOk" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "bOk",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by status ascending
    else if (clickedColumn === "status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status descending
    else if (clickedColumn === "status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the address passed on the form
  handleAddressSearch = () => {
    const searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.originalDevices[i].address === parseInt(this.state.formInput)) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the status passed on the form
  handleStatusSearch = (statusArray) => {
    const searchedDevices = [];

    for (let i = 0; i < statusArray.length; i++) {
      for (let j = 0; j < this.state.originalDevices.length; j++) {
        if (this.state.originalDevices[j].status === statusArray[i]) {
          searchedDevices.push(this.state.originalDevices[j]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    If the user typed a substring of one of the possible status: (In uppercase, lowercase or a mix of them)
    it returns and array containing the indexes to match against the json received from the server
  */
  matchFormInputStatus = () => {
    let matchedArray = [-1];
    let matchedIndex = 0;

    for (let i = 0; i < statusKeyArray.length; i++) {
      // Uppercases the user input before comparison to allow for a more flexible search
      // It doesn't matter if the user typed in uppercase, lowercase or any combination of them
      const status = statusKeyArray[i].toUpperCase();
      const upperCaseUserInput = this.state.formInput.toUpperCase();
      if (status.indexOf(upperCaseUserInput) !== -1) {
        matchedArray[matchedIndex] = i;
        matchedIndex++;
      }
    }

    return matchedArray;
  }

  /*
    Filters the page list showing only the devices that match the address or status typed in the form
  */
  handleSubmit = () => {
    const matchValueArray = this.matchFormInputStatus();
    let auxArray = [];

    for (let i = 0; i < matchValueArray.length; i++) {
      auxArray.push(statusValueArray[matchValueArray[i]]);
    }

    if (this.state.formInput !== "" && matchValueArray[0] !== -1) {
      this.handleStatusSearch(auxArray);
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
    // If what the user typed is not a status and the form is not blank, try to see if he typed a number
    else {
      this.handleAddressSearch();
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user didn't 
    // sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {

      let monitorIP = await fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "monitorIP", { mode: "cors", signal: this.state.controller.signal })
        .then(res => res.json())
        .then(data => data.monitorAddr)
        .catch(() => {
          return "";
        });

      let liveListMonitor = [];

      if (monitorIP !== "") {
        liveListMonitor = await new Promise((resolve, reject) => {
          let didTimeOut = false;

          const timeout = setTimeout(() => {
            didTimeOut = true;
            reject(new Error("Request timed out!"));
          }, 200);

          return fetch("http://" + monitorIP + ":5000/", { mode: "cors", signal: this.state.controller.signal })
            .then((res) => {
              clearTimeout(timeout);
              resolve(res);
            })
            .catch((error) => {
              // Rejection already happened with setTimeout
              if (didTimeOut) return;
              // Reject with error
              reject(error);
            });
        })
          .then(res => res.json())
          .then(data => data)
          .catch(() => {
            return [];
          });
      }

      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS, { mode: "cors", signal: this.state.controller.signal })
          .then(res => res.json())
          .then(data => data)
          .catch(() => "")
      );

      promissesArray.push(
        fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "networkData", { mode: "cors", signal: this.state.controller.signal })
          .then(res => res.json())
          .then(data => data)
          .catch(() => "")
      );

      promissesArray.push(
        fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "homePage", { mode: "cors", signal: this.state.controller.signal })
          .then(res => res.json())
          .then(data => data)
          .catch(() => "")
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      if (resolvedPromisses[0] !== ""
        && resolvedPromisses[1] !== ""
        && resolvedPromisses[2] !== "") {

        let liveList = resolvedPromisses[0].sort(UtilsInstance.sortBy(
          "address",
          false,
          function (a) { return a; }));

        liveList = UtilsInstance.addTagToDevices(liveList, liveListMonitor);
        let networkData = resolvedPromisses[1];
        let homePageData = resolvedPromisses[2];

        this.setState({
          devices: liveList,
          originalDevices: liveList,
          baudrate: networkData.baudrate,
          nMasters: networkData.nMasters,
          nSlaves: networkData.nSlaves,
          tensaoIdle: networkData.tensaoIdle,
          networkTag: homePageData.networkTag,
          uptime: this.formatToRelativeTime(homePageData.uptime)
        }, () => {
          if (this.state.tensaoIdle < 0.6 && this.state.nSlaves > 0) {
            document.getElementById("tensao-idle-statistic").style = "background: orange;";
          }
          else {
            document.getElementById("tensao-idle-statistic").style = "background: white;";
          }
          this.setBaudRateQuantity();
          this.addSeverityLevelToDevices();
        });
      }
    }
  }

  createWaveStatusCell = (isWaveOk) => {
    if (isWaveOk) {
      return <Icon name="check circle" color="green" size="big" />;
    }
    else {
      return <Icon name="exclamation circle" color="yellow" size="big" />;
    }
  }

  createNoiseCell = (withNoise) => {
    if (!withNoise) {
      return <Icon name="check circle" color="green" size="big" />;
    }
    else {
      return <Icon name="exclamation circle" color="yellow" size="big" />;
    }
  }

  /* 
    Create Status Cell
    parameters: 
    - device: JSON information of the device being added to the table
    - return: A new table cell stylized according to the current device status
  */
  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      if (device.hasWaveProblem) {
        return (
          <Table.Cell
            selectable
            width={2}
            style={okFadedCellStyle}>
            {Strings.GOOD_STRING}
          </Table.Cell>
        );
      }
      else {
        return (
          <Table.Cell
            selectable
            width={2}
            style={okCellStyle}>
            {Strings.GOOD_STRING}
          </Table.Cell>
        );
      }

    }
    else if (device.status === Constants.ATTENTION) {
      if (device.hasWaveProblem) {
        return (
          <Table.Cell
            selectable
            width={2}
            style={attentionFadedCellStyle}>
            {Strings.ATTENTION_STRING}
          </Table.Cell>
        );
      }
      else {
        return (
          <Table.Cell
            selectable
            width={2}
            style={attentionCellStyle}>
            {Strings.ATTENTION_STRING}
          </Table.Cell>
        );
      }
    }
    else if (device.status === Constants.BAD) {
      if (device.hasWaveProblem) {
        return (
          <Table.Cell
            selectable
            width={2}
            style={badFadedCellStyle}>
            {Strings.BAD_STRING}
          </Table.Cell>
        );
      }
      else {
        return (
          <Table.Cell
            selectable
            width={2}
            style={badCellStyle}>
            {Strings.BAD_STRING}
          </Table.Cell>
        );
      }
    }
    else {
      return (
        <Table.Cell
          selectable
          width={2}
          style={unknownCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  /*
    Adjusts the size of the table so that it does not exceed the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY_DP;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  setBaudRateQuantity = () => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    let baudRateKbps = (this.state.baudrate / 1000).toString();
    let baudRateMbps = (this.state.baudrate / 1000000).toString();

    let baudRateKbpsText = baudRateKbps.toString();
    let baudRateMbpsText = baudRateMbps.toString();

    if (lang !== Constants.EN_LANG_KEY) {
      baudRateKbpsText = UtilsInstance.replacePointWithComma(baudRateKbpsText);
      baudRateMbpsText = UtilsInstance.replacePointWithComma(baudRateMbpsText);
    }

    // If the baur rate is greater then 1000 Kbps show it as Mbps
    if (baudRateKbps >= 1000.00) {
      document.getElementById("baud_rate_speed").innerHTML = baudRateMbpsText;
      document.getElementById("baud_rate_order_of_magnitude").innerHTML = Strings.BAUD_RATE_MBPS;
    }
    else {
      document.getElementById("baud_rate_speed").innerHTML = baudRateKbpsText;
      document.getElementById("baud_rate_order_of_magnitude").innerHTML = Strings.BAUD_RATE_KBPS;
    }
  }

  getTensaoIdleText = (tensaoIdle) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    let tensaoIdleText = tensaoIdle.toFixed(2);

    if (lang !== Constants.EN_LANG_KEY) {
      tensaoIdleText = UtilsInstance.replacePointWithComma(tensaoIdleText);
    }

    return tensaoIdleText + " " + Strings.VOLTAGE_PEAK_TO_PEAK;
  }

  getAmpImage = () => (<Image src={`${process.env.PUBLIC_URL}/images/amp_media.png`} />);

  getMinAmpImage = () => (<Image src={`${process.env.PUBLIC_URL}/images/amp_min.png`} />);

  getOvershootingImage = () => (<Image src={`${process.env.PUBLIC_URL}/images/overshooting.png`} />);

  getIdleImage = () => (<Image src={`${process.env.PUBLIC_URL}/images/idle_desc_img.png`} />);

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = () => {
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "warnings", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => {
        this.handleWarningMessages(data);
      })
      .catch((error) => {
        console.log("Warnings interrupted: ", error);
      });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.invertedAB || errors.picoNotFound || errors.monitorIPNotFound) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.invertedAB) {
        errorMessages.push(Strings.INVERTED_AB);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.monitorIPNotFound) {
        errorMessages.push(Strings.MONITOR_IP_NOT_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {

        document.getElementById("message-list").style.display = "none";

      }

      this.setState({ errorMessages: [] });
    }
  }

  getAmplitudeValue = (device) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (lang !== Constants.EN_LANG_KEY) {
      return UtilsInstance.replacePointWithComma(device.amplitude.toFixed(2)) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
    else {
      return device.amplitude.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
  }

  getAmplitudeMinValue = (device) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (lang !== Constants.EN_LANG_KEY) {
      return UtilsInstance.replacePointWithComma(device.amplitudeMin.toFixed(2)) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
    else {
      return device.amplitudeMin.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
  }

  getOvershootingValue = (device) => {
    return (device.overshooting.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK);
  }

  getResponseTimeValue = (responseTime) => {
    if (responseTime !== undefined && responseTime !== null && responseTime !== "-") {
      const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

      if (lang !== Constants.EN_LANG_KEY) {
        return UtilsInstance.replacePointWithComma(responseTime.toFixed(2)) + Strings.MICROSSECOND;
      }
      else {
        return responseTime.toFixed(2) + Strings.MICROSSECOND;
      }
    }
    else {
      return responseTime;
    }
  }

  getMeanAmplitudeHeaderText = (amplitudeText1, amplitudeText2) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);
    let amplitudeSpanStyle = {
      marginLeft: "16px"
    };

    if (lang === Constants.EN_LANG_KEY) {
      if (amplitudeText1 === Strings.MIN_AMPLITUDE_1) {
        amplitudeSpanStyle.marginLeft = "0px";
      }

      return (
        <>
          <span style={amplitudeSpanStyle}>
            {amplitudeText1} <Icon name="info circle" color="teal" />
          </span> < br />
          {amplitudeText2}
        </>
      );
    }
    else {
      return (
        <>
          {amplitudeText1} < br />
          <span style={amplitudeSpanStyle}>
            {amplitudeText2}<Icon name="info circle" color="teal" />
          </span>
        </>
      );
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveWarnings();
    // store intervalId in the state so it can be accessed later
    this.setState({
      intervalID: setInterval(this.retrieveData, 1000),
      warningsIntervalID: setInterval(this.retrieveWarnings, 1000)
    });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
    clearInterval(this.state.warningsIntervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.address}>
        <Table.Cell width={1} verticalAlign="middle">{device.address}{UtilsInstance.getMasterSuffix(device.isMaster)}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{device.tag}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getAmplitudeMinValue(device)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getAmplitudeValue(device)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getResponseTimeValue(device.responseTime)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getResponseTimeValue(device.responseTimeMax)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.createNoiseCell(device.noise)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.createWaveStatusCell(device.aOk)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.createWaveStatusCell(device.bOk)}</Table.Cell>
        {this.createStatusCell(device)}
      </Table.Row>
    ));

    return (
      <div style={screenStyle}>

        <Grid doubling columns={3} style={{ marginBottom: "-24pt" }}>
          <Grid.Row>
            <Grid.Column>
            </Grid.Column>

            <Grid.Column verticalAlign='middle'>
              <Form onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER_DP}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column verticalAlign='middle'>
              <Segment style={floatStyle} compact textAlign="center">
                <Icon color="green" name="arrow alternate circle up" />
                {Strings.TIME_ON}{this.state.uptime}
              </Segment>
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Grid columns={2} doubling>
          <Grid.Row>

            <Grid.Column width={3}>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.NETWORK_DATA}</Divider>
                <Statistic.Group widths={1} size="mini">
                  <Statistic>
                    <Statistic.Value id="baud_rate_speed">0</Statistic.Value>
                    <Statistic.Label id="baud_rate_order_of_magnitude">{Strings.BAUD_RATE_KBPS}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.nMasters}</Statistic.Value>
                    <Statistic.Label>{Strings.MASTERS}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.nSlaves}</Statistic.Value>
                    <Statistic.Label>{Strings.SLAVES}</Statistic.Label>
                  </Statistic>
                  <Statistic id="tensao-idle-statistic">
                    <Statistic.Value>{this.getTensaoIdleText(this.state.tensaoIdle)}</Statistic.Value>
                    <Statistic.Label>
                      {Strings.AMPLITUDE_IDLE}
                      <Popup wide position='right center' hoverable
                        trigger={<Icon name="info circle" color="teal" />}>
                        <Popup.Content>
                          <p style={{ textAlign: "justify" }}>
                            <b>Idle:</b>
                            {Strings.IDLE_DESCRIPTION}
                          </p>
                          <p style={{ textAlign: "justify" }}>
                            <b>{Strings.SEARCH_POPUP_6_1}</b>{Strings.IDLE_DESCRIPTION_2}
                          </p>
                          {this.getIdleImage()}
                        </Popup.Content>
                      </Popup >
                    </Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.networkTag}</Statistic.Value>
                    <Statistic.Label>{Strings.NETWORK_TAG}</Statistic.Label>
                  </Statistic>
                </Statistic.Group>
              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}
                >
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={13}>
              <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
                <Table.Header>
                  <Table.Row>

                    <Table.HeaderCell
                      width={1}
                      sorted={column === "address" ? direction : null}
                      onClick={this.handleSort("address")}>
                      {Strings.ADDRESS}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width={2}
                      sorted={column === "tag" ? direction : null}
                      onClick={this.handleSort("tag")}>
                      {Strings.TAG}
                    </Table.HeaderCell>

                    <Popup wide position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={1}
                          sorted={column === "minAmplitude" ? direction : null}
                          onClick={this.handleSort("minAmplitude")}>
                          {this.getMeanAmplitudeHeaderText(Strings.MIN_AMPLITUDE_1, Strings.MIN_AMPLITUDE_2)}
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.AMPLITUDE_MIN_DESC} </p>
                        <p>{Strings.AMPLITUDE_MIN_DESC_2} </p>
                        {this.getMinAmpImage()}
                      </Popup.Content>
                    </Popup >

                    <Popup wide position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={1}
                          sorted={column === "amplitude" ? direction : null}
                          onClick={this.handleSort("amplitude")}>
                          {this.getMeanAmplitudeHeaderText(Strings.MEAN_AMPLITUDE_1, Strings.MEAN_AMPLITUDE_2)}
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.MEAN_AMPLITUDE_DESC} </p>
                        <p>{Strings.MEAN_AMPLITUDE_DESC_2}</p>
                        {this.getAmpImage()}
                      </Popup.Content>
                    </Popup >

                    <Popup wide position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={1}
                          sorted={column === "responseTime" ? direction : null}
                          onClick={this.handleSort("responseTime")}>
                          T<sub>resp</sub> <Icon name="info circle" color="teal" /> <br />
                          {Strings.CURRENT}
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>T<sub>resp</sub>{Strings.RESPONSE_TIME_POPUP}</p>
                      </Popup.Content>
                    </Popup>

                    <Popup wide position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={1}
                          sorted={column === "responseTimeMax" ? direction : null}
                          onClick={this.handleSort("responseTimeMax")}>
                          T<sub>resp</sub> <Icon name="info circle" color="teal" /> <br />
                          {Strings.MAXIMUM}
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.MAX_RESPONSE_TIME_POPUP}</p>
                      </Popup.Content>
                    </Popup>

                    <Table.HeaderCell
                      width={1}
                      sorted={column === "noise" ? direction : null}
                      onClick={this.handleSort("noise")}>
                      {Strings.NOISE}
                    </Table.HeaderCell>

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={1}
                          sorted={column === "aOk" ? direction : null}
                          onClick={this.handleSort("aOk")}
                          verticalAlign="middle">
                          {Strings.A}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.CHANNEL_A_PROBLEM}</p>
                        <ul>
                          <li>{Strings.CHANNEL_DESCRIPTION_1}</li>
                          <li>{Strings.CHANNEL_DESCRIPTION_2}</li>
                          <li>{Strings.CHANNEL_DESCRIPTION_3}</li>
                          <li>{Strings.CHANNEL_DESCRIPTION_4}</li>
                        </ul>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={1}
                          sorted={column === "bOk" ? direction : null}
                          onClick={this.handleSort("bOk")}
                          verticalAlign="middle">
                          {Strings.B}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.CHANNEL_B_PROBLEM}</p>
                        <ul>
                          <li>{Strings.CHANNEL_DESCRIPTION_1}</li>
                          <li>{Strings.CHANNEL_DESCRIPTION_2}</li>
                          <li>{Strings.CHANNEL_DESCRIPTION_3}</li>
                          <li>{Strings.CHANNEL_DESCRIPTION_4}</li>
                        </ul>
                      </Popup.Content>
                    </Popup >

                    <Popup wide="very" position='bottom right' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "status" ? direction : null}
                          onClick={this.handleSort("status")}>
                          {Strings.SIGNAL}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content style={{ textAlign: "center", fontSize: "10pt" }}>
                        <div>
                          <p style={popupTitleStyle}>{Strings.SIGNAL_QUALITY}</p>
                          {Strings.SIGNAL_QUALITY_DESCRIPTION_1}
                          <div style={popupTitleStyle}>{Strings.GOOD}</div>
                          {Strings.GOOD_DESCRIPTION_1}<sub>pp</sub>{Strings.GOOD_DESCRIPTION_2}<br />
                          <div style={popupTitleStyle}>{Strings.ATTENTION}</div>
                          {Strings.ATTENTION_DESCRIPTION_1}<sub>pp</sub>{Strings.ATTENTION_DESCRIPTION_2}<br />
                          {Strings.ATTENTION_DESCRIPTION_3}<sub>pp</sub>{Strings.ATTENTION_DESCRIPTION_4}<br />
                          <div style={popupTitleStyle}>{Strings.BAD}</div>
                          {Strings.BAD_DESCRIPTION_1}<sub>pp</sub>{Strings.BAD_DESCRIPTION_2}<sub>pp</sub>{Strings.BAD_DESCRIPTION_3}<br />
                          {Strings.BAD_DESCRIPTION_4}<sub>pp</sub>{Strings.BAD_DESCRIPTION_5}
                          <div style={popupTitleStyle}>{Strings.LIGHT_TONES}</div>
                          {Strings.LIGHT_TONES_DESCRIPTION}
                        </div>
                      </Popup.Content>
                    </Popup >

                  </Table.Row>
                </Table.Header>
              </Table>

              <div id="main-table-container" style={tableStyle}>
                <Table id="main-table" sortable striped celled fixed selectable textAlign="center" columns={7}>
                  <Table.Body>{devices}</Table.Body>
                </Table>
              </div>

            </Grid.Column>

          </Grid.Row>
        </Grid >

      </div >
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginBottom: "1vh",
  width: "99.4%"
};

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const okFadedCellStyle = {
  color: "black",
  backgroundColor: "rgba(0, 255, 0, 0.3)",
  verticalAlign: "middle"
};

const attentionFadedCellStyle = {
  color: "black",
  backgroundColor: "rgba(255, 255, 0, 0.3)",
  verticalAlign: "middle"
};

const badFadedCellStyle = {
  color: "black",
  backgroundColor: "rgba(255, 87, 34, 0.3)",
  verticalAlign: "middle"
};

const unknownCellStyle = {
  color: "black",
  backgroundColor: "lightgrey",
  verticalAlign: "middle"
};

const floatStyle = {
  float: "right",
  textAlign: "right"
};

const spanStyle = {
  float: "right"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const popupTitleStyle = {
  fontWeight: "bold"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

export default withRouter(LiveList);
